module.exports = __webpack_public_path__ + "img/tn-timeline-main-8.3f375104.jpg";